export enum FoldersEnum {
  KYC = 1,
  Bank = 2,
  Currency = 3,
  PartnerBusiness = 4,
  LoginProvider = 5,
  Announcements = 6,
}
